export const stripParenthesis = (value: string): string => value.replace(/\([^()]*\)/g, '')
